import React, { useState, MouseEvent, ChangeEvent } from 'react'
import QuestionState from '../../types/QuestionState'
import ViewProps from '../../types/ViewProps'
import Answer from '../../types/Answer'
import Typed from '../Typed'

const SearchSelectModal = ({ choices, onClose, onChoice }: { choices: Array<string>, onClose: () => void, onChoice: (answer: string) => void }) => {
    const [hover, setHover] = useState<{
        x: number,
        y: number,
        width: number,
        height: number,
        done: boolean,
        term: string,
        results: Array<string>
    }>({
        x: 0,
        y: 0,
        width: 0,
        height: 0,
        done: false,
        term: '',
        results: choices
    })

    const onChange = (event: ChangeEvent<HTMLInputElement>) => {
        const results = choices.filter(c => c.toLowerCase().indexOf(event.target.value.toLowerCase()) === 0)
        setHover({ ...hover, term: event.target.value, results: results.length > 0 ? results : [] })
    }

    return (
        <div className={"modal-wrap"}>
            {/* <div className={"modal-close-button"} onClick={onClose}>&times;</div> */}
            <div className={"modal modal-radioselect" + (hover.done ? ' modal-finish' : '')}>
                <div className={"choices choices-radioselect" + (hover.done ? ' finish' : '')}
                    onMouseLeave={() => {
                        if (!hover.done) {
                            setHover({ ...hover, height: 0 })
                        }
                    }}
                >
                    <div className={'modal-search'}>
                        <input type="text" placeholder={'Search...'} onChange={onChange} autoFocus />
                    </div>
                    <div className={'hover' + (hover.done ? ' done' : '')} style={{ transform: `translate(${hover.x}px, ${hover.y}px)`, width: `${hover.width}px`, height: `${hover.height}px` }} />
                    {hover.results.length === 0 && (
                        <div>Nothing matched your search term</div>
                    )}
                    {hover.results.length > 0 && hover.results.map(q => (
                        <div
                            className="choice"
                            key={q}
                            onMouseEnter={(e) => {
                                if (!hover.done) {
                                    const target = e.target as HTMLElement
                                    setHover({
                                        x: target.offsetLeft,
                                        y: target.offsetTop,
                                        width: target.offsetWidth,
                                        height: target.offsetHeight,
                                        done: false,
                                        term: hover.term,
                                        results: hover.results
                                    })
                                }
                            }}
                            onClick={() => {
                                setHover({ ...hover, done: true })
                                setTimeout(() => {
                                    onChoice(q)
                                }, 200)
                            }}
                        >{q}</div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default ({ data, path, handleClick, appState, setAppState }: ViewProps) => {
    const q = data!.find(q => q.id === path)
    const defaultSelection: Answer = q!.answers[0]
    const choose: Answer = q!.answers[1]
    const choice: string = choose.choices!.includes(appState[path!] as string) ? appState[path!] as string : ''

    const [questionState, setQuestionState] = useState<QuestionState>({
        showModal: false,
        complete: false
    })

    if (appState[path!] === '') {
        setAppState({ ...appState, [path!]: ' ', next: defaultSelection.target })
    }

    const handleChange = (answer: string): void => {
        if (answer === 'No' && appState[path!] !== 'No' && appState[path!] !== 'Yes' && appState[path!] !== ' ') return

        setQuestionState({ ...questionState, complete: true })
        setAppState({ ...appState, [path!]: answer, next: defaultSelection.target })
        
        if (window.dataLayer) {
            window.dataLayer.push({ event: 'radioSelectChoice', radioSelectQuestion: q!.question, radioSelectAnswer: answer });
        }
    }

    const handleChoice = (answer: string) => {
        setQuestionState({ showModal: false, complete: true })
        setAppState({ ...appState, [path!]: answer, next: defaultSelection.target })
    }

    const handleOpen = () => {
        setQuestionState({ ...questionState, showModal: true })
    }

    const handleClose = () => {
        setQuestionState({ ...questionState, showModal: false })
    }

    const showNext = appState[path!] !== ' ' && appState[path!] !== 'No' && !questionState.showModal ? ' show' : ''
    const question = questionState.complete ? q!.question : <Typed>{q!.question}</Typed>

    return (
        <div>
            {!questionState.showModal && (
                <>
                <div className="question">
                    <div>
                        <h1>{question}</h1>
                        <div className={`answers answers-radioselect ${questionState.complete ? '' : 'animate'}`} style={{ animationDelay: `${q?.answerDelay}ms`}}>
                            <div className={`answer answer-radio`} onClick={() => handleChange(defaultSelection.text)}>
                                <input type="radio" name={q!.id}
                                    value={defaultSelection.text} checked={appState[path!] === defaultSelection.text} readOnly />
                                <span dangerouslySetInnerHTML={{ __html: defaultSelection.text }}></span>
                            </div>
                            <div className={`answer answer-radioselect`} onClick={() => handleChange(choose.text)}>
                                <input type="radio" name={q!.id} checked={appState[path!] !== ' ' && appState[path!] !== 'Yes'}
                                    value={choose.text} readOnly />
                                <span dangerouslySetInnerHTML={{ __html: choose.text }}></span>
                            </div>
                            {appState[path!] !== 'Yes' && appState[path!] !== ' ' && (
                                <>
                                <div className={`answer answer-country-chooser`} onClick={handleOpen}>
                                    {choice === '' ? 'Select a Country...' : choice}
                                </div>
                                <div className={`answer-help`}>This will help us provide you with relevant information.</div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
                <div onClick={handleClick} className={`nav-link nav-link-chooser nav-link--landing${showNext}`}>Next</div>
                </>
            )}
            {questionState.showModal && (
                <SearchSelectModal choices={choose.choices!} onChoice={handleChoice} onClose={handleClose} />
            )}
            
        </div>
    )
}